/*
  SND-14786 — two fixes on Shopify's native consent banner (#shopify-pc__banner),
  neither of which is reachable from the admin:

  1. Policy link. Shopify builds policyLinkUrl off the PRIMARY domain plus a
     language folder — https://soundium.com/lv/policies/privacy-policy — so every
     market domain (.lv/.lt/.ee/.se) sends the reader off-domain through a 301.
     We repoint the anchor at shop.privacy_policy.url, which Liquid already
     resolves locale-prefixed and relative, so the link stays on the domain the
     visitor is on. Applied in every language.

  2. Missing translations. Shopify ships banner copy for 18 of the store's 20
     languages but has none for lv and et, which fall back to English on
     soundium.lv / soundium.ee. For those locales the snippet hands us the theme's
     own strings (locales/lv.json, locales/et.json → snd_cookie) and we swap them
     into both the banner and the "Manage preferences" modal. Everywhere else
     window.SNDCookieBanner.strings is null and only fix 1 runs — Shopify keeps
     owning the copy it already translates.

  Text only. Consent logic, storage and the preferences plumbing stay Shopify's.
  Every write is compared first, so re-patching is a no-op and the MutationObserver
  cannot feed itself.
*/
(function () {
  var cfg = window.SNDCookieBanner;
  if (!cfg) return;
  var S = cfg.strings || null;

  function setText(el, value) {
    if (el && value && el.textContent !== value) el.textContent = value;
  }

  /* Leading text node of "<p>…copy… <a>Privacy Policy</a></p>" / "<label>Name<input></label>". */
  function setLeadingText(el, value) {
    if (!el || !value) return;
    var node = el.firstChild;
    if (node && node.nodeType === 3 && node.nodeValue !== value) node.nodeValue = value;
  }

  function patchBanner() {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner) return;

    var link = banner.querySelector('#shopify-pc__banner__body-policy-link');
    if (link && cfg.policyUrl && link.getAttribute('href') !== cfg.policyUrl) {
      link.setAttribute('href', cfg.policyUrl);
    }
    if (!S) return;

    setText(banner.querySelector('#shopify-pc__banner__body-title'), S.title);
    setLeadingText(banner.querySelector('.shopify-pc__banner__body p'), S.body + ' ');
    setText(link, S.policy_link);
    setText(banner.querySelector('#shopify-pc__banner__btn-accept'), S.accept);
    setText(banner.querySelector('#shopify-pc__banner__btn-decline'), S.decline);
    /* The manage button wraps its label in a span; older markup does not. */
    var manage = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    setText((manage && manage.querySelector('span')) || manage, S.manage);
  }

  function patchOption(root, id, name, desc) {
    var option = root.querySelector('#' + id);
    if (!option) return;
    setLeadingText(option.querySelector('label'), name);
    setText(option.querySelector('p'), desc);
  }

  function patchPrefs() {
    if (!S) return;
    var prefs = document.getElementById('shopify-pc__prefs');
    if (!prefs) return;

    setText(prefs.querySelector('#shopify-pc__prefs__header-title'), S.prefs_title);
    setText(prefs.querySelector('#shopify-pc__prefs__header-accept'), S.prefs_accept_all);
    setText(prefs.querySelector('#shopify-pc__prefs__header-decline'), S.prefs_decline_all);
    setText(prefs.querySelector('#shopify-pc__prefs__header-save'), S.prefs_save);

    var close = prefs.querySelector('#shopify-pc__prefs__header-close');
    if (close && S.prefs_close && close.getAttribute('aria-label') !== S.prefs_close) {
      close.setAttribute('aria-label', S.prefs_close);
    }

    setText(prefs.querySelector('.shopify-pc__prefs__intro-main h3'), S.prefs_intro_title);
    setText(prefs.querySelector('.shopify-pc__prefs__intro-main p'), S.prefs_intro_text);

    patchOption(prefs, 'shopify-pc__prefs__essential', S.cat_essential, S.cat_essential_desc);
    patchOption(prefs, 'shopify-pc__prefs__preferences', S.cat_personalization, S.cat_personalization_desc);
    patchOption(prefs, 'shopify-pc__prefs__marketing', S.cat_marketing, S.cat_marketing_desc);
    patchOption(prefs, 'shopify-pc__prefs__analytics', S.cat_analytics, S.cat_analytics_desc);
  }

  function patch() {
    patchBanner();
    patchPrefs();
  }

  patch();

  /* Shopify appends both dialogs straight to <body>, and re-appends the prefs
     modal on every open, so watching body's children is enough — no whole-document
     subtree observer. The prefs modal gets its own scoped observer once it exists,
     because its inner list is re-rendered in place when consent state changes. */
  var seenPrefs = null;
  function watchPrefs() {
    var prefs = document.getElementById('shopify-pc__prefs');
    if (!prefs || prefs === seenPrefs) return;
    seenPrefs = prefs;
    new MutationObserver(patch).observe(prefs, { childList: true, subtree: true });
  }

  var body = document.body || document.documentElement;
  new MutationObserver(function () {
    patch();
    watchPrefs();
  }).observe(body, { childList: true });
  watchPrefs();
})();
